const APP_NAME = process.env.REACT_APP_NAME || 'ThinkPad'

export default APP_NAME
